import { render, staticRenderFns } from "./KnowledgeGraph.vue?vue&type=template&id=3ef3edca&scoped=true"
import script from "./KnowledgeGraph.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraph.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeGraph.vue?vue&type=style&index=0&id=3ef3edca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3edca",
  null
  
)

export default component.exports